/*
* Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
*
* This file contains trade secrets of Honeywell International, Inc.  No part
*  may be reproduced or transmitted in any form by any means or for any
*  purpose without the express written permission of Honeywell.
*
*/

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from '../../environments/environment';
import { EventBody } from '../models';
import { FacilityService } from './facility.service';


@Injectable()
export class EventLoggerService {
    api_url: any;
    facilityId: string;
    STARTED_STATUS_CODE = 1;
    FAILURE_STATUS_CODE = 2;
    SUCCESS_STATUS_CODE = 3;

    constructor(private apiService: ApiService, private facilityService: FacilityService) {
        this.api_url = environment.eventLogger.api_url;
        this.setFacilityId();
    }

    logStartedEvent(activityType: number, activityLog: string) {
        if (!this.facilityId) {
            this.setFacilityId();
        }
        return this.logEvent(this.createEvent(activityType, activityLog, this.STARTED_STATUS_CODE));
    }

    logFailureEvent(activityType: number, activityLog: string) {
        if (!this.facilityId) {
            this.setFacilityId();
        }
        return this.logEvent(this.createEvent(activityType, activityLog, this.FAILURE_STATUS_CODE));
    }

    logSuccessEvent(activityType: number, activityLog: string) {
        if (!this.facilityId) {
            this.setFacilityId();
        }
        return this.logEvent(this.createEvent(activityType, activityLog, this.SUCCESS_STATUS_CODE));
    }

    logEvent(event: EventBody) {
        const logEventPath = '/onboarding/activitylog';
        return this.apiService.post(logEventPath, this.api_url, event);
    }

    setFacilityId() {
        this.facilityId = this.facilityService.getFacilityId();
    }

    createEvent(activityType: number, activityLog: string, status: number) {
        return {
            facilityId: this.facilityId,
            activityType: activityType,
            occurredTime: (new Date()).toISOString(),
            activityStatus: status,
            activityLog: activityLog
        };
    }
}
